exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TitleAndDescription-module__title-and-description___29VtF{display:flex;height:100%;flex-direction:column;justify-content:flex-start}", ""]);

// exports
exports.locals = {
	"title-and-description": "TitleAndDescription-module__title-and-description___29VtF"
};